import React, { useState } from "react";
import axios from "axios";

const UpdateOrderProduct = ({ rQty }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [return_qty, setReturnQuantity] = useState(0);

  const handleUpdate = async () => {
    try {
      const data = {
        sales_rate: rQty?.sales_rate,
        return_qty: return_qty,
      };
      const response = await axios.patch(
        `http://localhost:4001/api/order_one/${rQty?.inv_no}/${rQty?.id}`,
        data
      );

      if (response) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        setTimeout(() => {
          window.location.reload();
        }, 10);
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };
  return (
    <div>
      <span
        onClick={openModal}
        className=" font-bold text-blue-500 cursor-pointer"
      >
        R
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-md">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-6">
              <div className="card-body">
                <div className="text-center">
                  <h2 className=" font-bold">Return Product Quantity</h2>
                </div>
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="grid grid-cols-2 gap-4">
                    <div className="flex justify-between">
                      <h1 className="font-bold">Inv_no: {rQty?.inv_no}</h1>
                    </div>
                    <div className="flex justify-between">
                      <h1 className="font-bold">Product: {rQty?.pro_name}</h1>
                    </div>
                    <div className="flex justify-between">
                      <h1 className="font-bold">Sales Quantity: {rQty?.qty}</h1>
                    </div>
                    <div className="flex justify-between">
                      <label className="font-bold mr-1">Return Quantity:</label>
                      <input
                        type="number"
                        onChange={(e) => setReturnQuantity(e.target.value)}
                        className="border pl-1 w-16"
                      />
                    </div>
                  </div>
                  <button
                    onClick={() => handleUpdate()}
                    className="bg-green-500 text-white font-bold mt-4 px-2 rounded block m-auto"
                  >
                    Added
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateOrderProduct;